import React, { useState, useEffect } from 'react';
import AppBarWithMenu from '../app-bar-with-menu';
import { Container } from '@material-ui/core';
import MaterialTable, { Column } from 'material-table';
import illumass from '../../services/illumass';
import { Asset, EntityRef, SearchResult } from '@equestria/spike';
import { useSnackbar } from 'notistack';
import _ from 'lodash';
import InfoDialog from '../info-dialog';

const loadAssets = async (): Promise<Asset[]> => {
  let searchResult: SearchResult<Asset> | null = await illumass.asset.search(
    {},
    { size: 100, scroll: '30s' }
  );
  const collectedAssets: Asset[] = [];

  while (searchResult !== null) {
    searchResult.hits.forEach((hit) => collectedAssets.push(hit._source));
    searchResult = await searchResult.next();
  }

  return collectedAssets;
};

function Assets(): JSX.Element {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(true);
  const [assets, setAssets] = useState<Asset[]>([]);
  const [infoAsset, setInfoAsset] = useState<Asset | undefined>(undefined);

  const columns: Column<Asset>[] = [
    {
      title: 'Asset',
      field: 'name',
    },
  ];

  const handleInfoClick = (
    _event: React.MouseEvent<Element, MouseEvent> | undefined,
    row: Asset | Asset[]
  ): void => {
    if (_.isArray(row)) {
      setInfoAsset(row[0]);
    } else {
      setInfoAsset(row);
    }
  };

  const handleInfoClose = (): void => {
    setInfoAsset(undefined);
  };

  useEffect(() => {
    loadAssets()
      .then((searchedAssets) => {
        setLoading(false);
        setAssets(searchedAssets);
      })
      .catch((err) => {
        console.error(err);
        enqueueSnackbar('Unable to load assets.', { variant: 'error' });
        setLoading(false);
      });
  }, [enqueueSnackbar]);

  return (
    <React.Fragment>
      <AppBarWithMenu title="Assets" />
      <Container>
        <MaterialTable
          isLoading={loading}
          actions={[
            {
              icon: 'info',
              tooltip: 'Info',
              onClick: handleInfoClick,
            },
          ]}
          options={{
            showTitle: false,
            actionsColumnIndex: columns.length,
          }}
          localization={{
            body: {
              emptyDataSourceMessage: 'No assets',
            },
          }}
          columns={columns}
          data={assets}
          parentChildData={(row, rows): Asset | undefined =>
            rows.find((r) => r.id === (row.parent as EntityRef)?.id)
          }
        />
      </Container>
      <InfoDialog
        onClose={handleInfoClose}
        name={infoAsset?.name ?? ''}
        idRef={'asset!' + (infoAsset?.id ?? '')}
        slugRef={'asset.' + (infoAsset?.slug ?? '')}
        open={infoAsset !== undefined}
      />
    </React.Fragment>
  );
}

export default Assets;
